// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1hyeF","info":"Note_info__2Oklr","note":"Note_note__1jd0I","actions":"Note_actions__y99AJ"};